import React from 'react';
import { Link } from 'react-router-dom';

function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow rounded-lg p-8">
          <Link to="/" className="text-primary hover:text-secondary mb-4 inline-block">
            ← Back to Home
          </Link>
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Privacy Policy</h1>
          
          <div className="prose max-w-none">
            <p className="text-gray-600 mt-2">
              At Kova, we respect your privacy and are committed to protecting the personal information you share with us. This Privacy Policy outlines how we collect, use, and protect your data when you use our platform.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">1. Information We Collect</h2>
            <h3 className="text-lg font-medium text-gray-900 mt-4">a. Account Information</h3>
            <ul className="list-disc pl-6 text-gray-600 mt-2">
              <li>Name</li>
              <li>Email address</li>
              <li>Username</li>
              <li>Password (encrypted)</li>
              <li>Phone number</li>
            </ul>

            <h3 className="text-lg font-medium text-gray-900 mt-4">b. Transaction Information</h3>
            <ul className="list-disc pl-6 text-gray-600 mt-2">
              <li>Order details (products, pricing, timestamps)</li>
              <li>Escrow transaction records</li>
              <li>Communication between buyers and sellers</li>
              <li>Payment details (processed securely via third-party services)</li>
            </ul>

            <h3 className="text-lg font-medium text-gray-900 mt-4">c. Usage Data</h3>
            <ul className="list-disc pl-6 text-gray-600 mt-2">
              <li>IP address</li>
              <li>Browser and device information</li>
              <li>Date and time of access</li>
              <li>Interaction with platform features</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">2. How We Use Your Information</h2>
            <p className="text-gray-600 mt-2">
              We use your data to:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mt-2">
              <li>Create and manage user accounts</li>
              <li>Facilitate and secure escrow transactions</li>
              <li>Connect buyers and sellers</li>
              <li>Process payments and disbursements</li>
              <li>Monitor platform usage and improve our services</li>
              <li>Communicate updates, promotions, and support messages</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">3. Escrow and Payment Handling</h2>
            <p className="text-gray-600 mt-2">
              All transactions on Kova are backed by an escrow system. This means:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mt-2">
              <li>Funds are held securely until the buyer confirms receipt of the product.</li>
              <li>We partner with secure third-party payment processors. Kova does not store full credit/debit card information.</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">4. Data Sharing and Disclosure</h2>
            <p className="text-gray-600 mt-2">
              We do not sell your personal data. We may share information only:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mt-2">
              <li>With third-party services that help operate Kova (Paystack)</li>
              <li>To comply with legal obligations</li>
              <li>To investigate and prevent fraud or abuse of the platform</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">5. Your Rights</h2>
            <p className="text-gray-600 mt-2">
              You have the right to:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mt-2">
              <li>Access, update, or delete your account</li>
              <li>Request data portability</li>
              <li>Withdraw consent (where applicable)</li>
            </ul>
            <p className="text-gray-600 mt-2">
              To exercise any of these rights, contact us at [insert contact email].
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">6. Security</h2>
            <p className="text-gray-600 mt-2">
              We use encryption, secure access protocols, and monitoring to protect your data. However, no online service is completely immune to risks. We encourage users to use strong passwords and report any suspicious activity.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">7. Cookies</h2>
            <p className="text-gray-600 mt-2">
              We use cookies to improve your experience—such as keeping you signed in and remembering your preferences. You can manage cookies through your browser settings.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">8. Changes to This Policy</h2>
            <p className="text-gray-600 mt-2">
              We may update this Privacy Policy from time to time. We'll notify you via email or platform notifications when major changes are made.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6">9. Contact Us</h2>
            <p className="text-gray-600 mt-2">
              If you have questions or concerns about this policy, please contact us at:
            </p>
            <ul className="list-none pl-6 text-gray-600 mt-2">
              <li>📧 [raphaelwright@kovaonline.com]</li>
              <li>🌐 www.kovaonline.com</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy; 